<template>
  <WhitePage class="d-flex justify-content-center mb-3">
    <b-spinner class="m-5" label="Spinning"></b-spinner>
  </WhitePage>
</template>

<script>
import WhitePage from '@/components/WhitePage'
export default {
  components: {
    WhitePage
  },
  methods: {
    fetchFirst () {
      this.$store.dispatch('first')
        .then((response) => {
          if (response.to === "TITLE"){
            this.$router.push({ path: 'title' })
          } else if(response.to === "MAIN") {
            if(response.notify){
              response.notify.forEach((v)=>{
                this.$root.$bvToast.toast(v, {
                  autoHideDelay: 5000,
                  appendToast: true
                })
              })
            }
            this.$router.push({ path: 'result' })
          }
        })
    }
  },
  mounted () {
    this.fetchFirst()
  }
}
</script>
